export default "__VITE_ASSET__GdEI7oD3__"